import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationInformationNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M16 .175A15.825 15.825 0 1031.825 16 15.843 15.843 0 0016 .175zm0 30A14.176 14.176 0 1130.175 16 14.191 14.191 0 0116 30.175z"
        fill=""
      />
      <path d="M16.825 13h-1.65v10h1.65V13zm0-5h-1.65v2h1.65V8z" fill="" />
    </svg>
  )
);
SvgNavigationInformationNormalMedium.defaultProps = {
  color: "currentColor",
  size: 32,
  title: undefined,
  titleId: undefined,
};
SvgNavigationInformationNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationInformationNormalMedium;
